// extracted by css-extract-rspack-plugin
export default {"emptyThubmnail":"emptyThumbnailSVG_emptyThubmnail__cjvzA"};